import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './style.less';

export default function ({ className = "", data = [], onChange }) {

    useEffect(() => {
        window.addEventListener("popstate", function (e) {
            // alert("我监听到了浏览器的返回按钮事件啦");//根据自己的需求实现自己的功能
            // console.log(e.state)
            // console.log(window.history.state)
        }, false);
    }, [])

    function onClickHandler(i) {
        if (onChange) onChange(data.splice(0, i + 1));
    }

    return (
        <div className={`com-nav ${className}`}>
            {data.map(({ label, link }, i) => <Link key={link} onClick={onClickHandler.later(i)} className="com-nav__item" to={link}>{label}</Link>)}
        </div>
    )
}